import { Gift } from "lucide-react";
import { useLang } from "@/lib/i18n";

const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
const DAYS_IN = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

/** Date d'anniversaire facultative (jour + mois) : -15 % offerts le jour J. value = { day, month }. */
export function BirthdayField({ value, onChange, testid = "birthday", tone = "dark" }) {
  const sel = `h-11 rounded-sm border border-[var(--line)] px-2 text-sm outline-none focus:border-[var(--gold)] ${tone === "dark" ? "bg-[var(--ink-2)]" : "bg-[var(--ink)]"}`;
  const max = value.month ? DAYS_IN[Number(value.month) - 1] : 31;
  const { t, lang } = useLang();
  const monthName = (i) => (lang === "en" ? new Date(2000, i, 1).toLocaleDateString("en-GB", { month: "long" }) : MONTHS[i]);
  return (
    <fieldset data-testid={testid} className="space-y-2">
      <legend className="flex items-center gap-2 text-xs text-[var(--parchment)]/85"><Gift className="h-3.5 w-3.5 text-[var(--gold)]" />{t("Votre anniversaire (facultatif) : -15 % offerts le jour J")}</legend>
      <div className="flex gap-2">
        <select aria-label={t("Jour")} data-testid={`${testid}-day`} value={value.day} onChange={(e) => onChange({ ...value, day: e.target.value })} className={`${sel} w-24`}>
          <option value="">{t("Jour")}</option>{Array.from({ length: max }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
        </select>
        <select aria-label={t("Mois")} data-testid={`${testid}-month`} value={value.month} onChange={(e) => onChange({ day: Number(value.day) > DAYS_IN[Number(e.target.value) - 1] ? "" : value.day, month: e.target.value })} className={`${sel} flex-1`}>
          <option value="">{t("Mois")}</option>{MONTHS.map((m, i) => <option key={m} value={i + 1}>{monthName(i)}</option>)}
        </select>
      </div>
    </fieldset>
  );
}
